// @flow
import { schema } from 'normalizr'

export const PAGE_SIZE = 10
export const MIN_OFFSET = 2

export const domains = {
  USERS: 'users',
  USER_ADDRESS: 'userAddress',
  CHARITIES: 'charities',
  AUCTIONS: 'auctions',
  ITEMS: 'items',
  BIDS: 'bids',
  SESSION: 'session',
  AUCTION_RESULTS_FOR_USER: 'auctionResultsForUser',
  MEDIA: 'media',
  CONTACTS: 'contacts',
  CHECKOUT: 'checkout',
  CHECKOUT_ITEM: 'checkoutItem',
  NOTIFICATIONS: 'notifications'
}

const userSchema = new schema.Entity(domains.USERS)
const userAddressSchema = new schema.Entity(domains.USER_ADDRESS)
const charitySchema = new schema.Entity(domains.CHARITIES)
const contactSchema = new schema.Entity(domains.CONTACTS)
const auctionSchema = new schema.Entity(domains.AUCTIONS)
const itemSchema = new schema.Entity(domains.ITEMS)
const mediaSchema = new schema.Entity(domains.MEDIA)
const bidSchema = new schema.Entity(domains.BIDS)
const checkoutSchema = new schema.Entity(domains.CHECKOUT)
const checkoutItemSchema = new schema.Entity(domains.CHECKOUT_ITEM)
const notificationSchema = new schema.Entity(domains.NOTIFICATIONS)

// define relations
userSchema.define({
  charities: [charitySchema],
  bids: [bidSchema],
  checkouts: [checkoutSchema],
  checkoutItems: [checkoutItemSchema],
  userAddresses: [userAddressSchema]
})
charitySchema.define({
  contacts: [contactSchema],
  auctions: [auctionSchema]
})
auctionSchema.define({
  charity: charitySchema,
  items: [itemSchema]
})
itemSchema.define({
  auction: auctionSchema,
  bids: [bidSchema],
  currentBid: bidSchema,
  media: [mediaSchema]
})
checkoutSchema.define({
  auction: auctionSchema,
  user: userSchema,
  userAddress: userAddressSchema,
  checkoutItems: [checkoutItemSchema]
})
checkoutItemSchema.define({
  checkout: checkoutSchema,
  item: itemSchema,
  user: userSchema,
  auction: auctionSchema
})

export const schemas = {
  charities: charitySchema,
  auctions: auctionSchema,
  items: itemSchema,
  bids: bidSchema,
  media: mediaSchema,
  contacts: contactSchema,
  checkout: checkoutSchema,
  checkoutItem: checkoutItemSchema,
  notification: notificationSchema
}

export const auctionStates = ['pending', 'live', 'closed', 'draft']

export const MEDIA_TYPE = {
  IMAGE: 'image',
  VIDEO: 'video'
}



// WEBPACK FOOTER //
// ./src/services/constants.js